'use client';
import React from 'react';
import styles from './payment-header.module.scss';
import Image from 'next/image';
import { HEADER } from '~/constant/payment-header';

interface HeaderProps {
  showTitle?: boolean;
}

const PaymentHeader: React.FC<HeaderProps> = ({ showTitle = true }) => {
  const { headerLogo, title } = HEADER;
  return (
    <header className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.logoSection}>
          <a href={headerLogo.homepageUrl} aria-label={headerLogo.ariaLabel}>
            <Image
              src={headerLogo.iconURL}
              height={28}
              width={30.5}
              alt={headerLogo.iconAlt}
            />
          </a>
          {showTitle && <h2 tabIndex={0}>{title.label}</h2>}
        </div>
      </div>
    </header>
  );
};

export default PaymentHeader;
